import styled, { css } from 'styled-components'

type Props = {
    rowConfiguration?: string
    columnConfiguration?: string
    $height?: string
}

export const Container = styled.div<Props>(
    ({ rowConfiguration, columnConfiguration }) => css`
        display: grid;
        grid-template-rows: ${rowConfiguration ? rowConfiguration : '1fr'};
        grid-template-columns: ${columnConfiguration ? columnConfiguration : 'repeat(2, 1fr)'};
    `,
)
export const ImageContainer = styled.div<{ imageContainerPadding?: string; margin?: string }>(
    ({ imageContainerPadding, margin }) => css`
        padding: ${imageContainerPadding ? imageContainerPadding : 0};
        position: relative;
        ${!!margin && `margin: ${margin}`};
    `,
)

export const ImageTopLeftContainer = styled.div`
    top: 0;
    left: 0;
    position: absolute;
    z-index: 1;
`

export const ImageTopRightContainer = styled.div`
    top: 0;
    right: 0;
    position: absolute;
    z-index: 1;
`

export const InformationContainer = styled.div<Props>(
    ({ rowConfiguration, $height, columnConfiguration }) => css`
        display: grid;
        width: 100%;
        grid-template-rows: ${rowConfiguration ? rowConfiguration : 'repeat(2, 1fr)'};
        height: ${$height ? $height : '12.25rem'};
        grid-template-columns: ${columnConfiguration ? columnConfiguration : 'repeat(2, 1fr)'};
    `,
)

export const Cell = styled.div<{ gridRow?: string; gridColumn?: string }>(
    ({ gridRow, gridColumn }) => css`
        min-width: 0;
        ${gridRow ? `grid-row: ${gridRow}` : ``};
        ${gridColumn ? `grid-column: ${gridColumn}` : ``};
    `,
)

export const TopLeft = styled(Cell)``

export const TopRight = styled(Cell)``

export const BottomLeft = styled(Cell)``

export const BottomRight = styled(Cell)``
